module.exports = __webpack_public_path__ + "img/validation-success.a8cf5934.png";